<template>

  <div class="works_content" v-loading="loading">
    <!-- 工作台页面 -->
    <Breadcrumb />
    <el-container class="main_box" id="works">
      <!-- 党支部界面 -->
      <el-main class="main_info" v-if="isworks">
        <ul v-if="$store.state.IsBranch" class="works_list clearfix">
          <li v-for="(e,i) in BranchMenu" :key="i" @click="RouteGo(e.route)">
            <i class="icon" :class="e.icon"></i>
            <strong>{{e.name}}</strong>
          </li>
        </ul>
        <ul v-if="!$store.state.IsBranch" class="works_list clearfix">
          <li v-for="(e,i) in OrgMenu" :key="i" @click="RouteGo(e.route)">
            <i class="icon" :class="e.icon"></i>
            <strong>{{e.name}}</strong>
          </li>
        </ul>
      </el-main>
      <!-- 党委界面 -->
      <el-main v-else>
        <el-container>
          <el-aside class="works_side" width="14%">
            <div class="shadow_box hc_card">
              <!-- <h3>{{SideTitle}}</h3> -->
              <Sidebar />
            </div>
          </el-aside>
          <el-main class="nopadding">
            <router-view></router-view>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
  </div>
</template>
<script>
  import Sidebar from '@/components/Sidebar'
  import Breadcrumb from '@/components/Breadcrumb'
  import {
    getcookie
  } from "@/assets/js/auth"
  export default {
    data() {
      return {
        BranchMenu: [
          {
            name: "党组织概况",
            route: "Abouts",
            icon: "i_group17"
          },
          {
            name: "会议管理",
            route: "CreatMeeting",
            icon: "i_group1"
          },
          {
            name: "文件管理",
            route: "FileManageMent",
            icon: "i_group6"
          },
          {
            name: "党务公开",
            route: "EventRecordCreat",
            icon: "i_group5"
          },
          {
            name: "发展党员",
            route: "Growing",
            icon: "i_group9"
          },
          {
            name: "党费管理",
            route: "CollectMoney",
            icon: "i_group16"
          },
          {
            name: "任务下达",
            route: "TaskRelease",
            icon: "i_group20"
          },
          {
            name: "我的任务",
            route: "TaskBranch",
            icon: "i_group23"
          },
          {
            name: "量化积分排行榜",
            route: "RankingBranch",
            icon: "i_group21"
          },
          {
            name: "述职述廉",
            route: "WorkReport",
            icon: "i_group22"
          },
          {
            name: "党内关爱",
            route: "CareHelp",
            icon: "i_group24"
          },
          {
            name: "党员示范岗",
            route: "Demonstration",
            icon: "i_group11"
          },
          {
            name: "荣誉管理",
            route: "HonorWall",
            icon: "i_group25"
          },
          {
            name: "课件资源",
            route: "CoursewarEventSigne",
            icon: "i_group8"
          },
          {
            name: "资料查询",
            route: "DataQuerySystem",
            icon: "i_group3"
          },
          {
            name: "线下阵地",
            route: "Case",
            icon: "i_group7"
          },
          {
            name: "数据统计",
            route: "BranchStatistics",
            icon: "i_group26"
          },
          {
            name: "组织邀请",
            route: "InvitationLink",
            icon: "i_group27"
          },
        ],
        OrgMenu: [
          {
            name: "党组织概况",
            route: "Abouts",
            icon: "i_group17"
          },
          {
            name: "会议管理",
            route: "CreatMeeting",
            icon: "i_group1"
          },
          {
            name: "文件管理",
            route: "FileManageMent",
            icon: "i_group6"
          },
          {
            name: "任务下达",
            route: "TaskLeader",
            icon: "i_group23"
          },
          {
            name: "我的任务",
            route: "TaskBranch",
            icon: "i_group23"
          },
          {
            name: "量化积分排行榜",
            route: "RankingLeader",
            icon: "i_group21"
          },
          {
            name: "述职述廉",
            route: "WorkReport",
            icon: "i_group22"
          },
          {
            name: "党内关爱",
            route: "CareHelp",
            icon: "i_group24"
          },
          {
            name: "发展党员",
            route: "Growing",
            icon: "i_group9"
          },
          {
            name: "党费管理",
            route: "DWCollectMoney",
            icon: "i_group16"
          },
          {
            name: "课件资源",
            route: "CoursewarEventSigne",
            icon: "i_group8"
          },
          {
            name: "资料查询",
            route: "DataQuerySystem",
            icon: "i_group3"
          },
          {
            name: "线下阵地",
            route: "Case",
            icon: "i_group7"
          },
          {
            name: "荣誉管理",
            route: "HonorWall",
            icon: "i_group25"
          },
          {
            name: "党务公开",
            route: "EventRecordComplete",
            icon: "i_group5"
          },
          {
            name: "数据统计",
            route: "BranchStatistics",
            icon: "i_group27"
          },
        ],
        loading: true,
        isworks: true,
        MenuList: [],
        SideTitle: null,
        branchID: null,
      }
    },
    watch: {
      '$route'(to, from) {
        this.isworks = to.meta.moudles === true ? true : false
      }
    },
    components: { Sidebar, Breadcrumb },
    methods: {
      getMeta() {
        this.isworks = this.$route.meta.moudles === true ? true : false
        this.loading = false
      },
      topath(url) {
        this.$router.push(url);
      }
    },
    created() {
      this.branchID = sessionStorage.getItem('ISCOM')
      let unit_category = getcookie('unitCategory')
      //针对不同的单位分类动态添加相应的模块
      let linshi = [
      //   {
      //   name: "党员、职工素质培训",
      //   route: "TrainingList",
      //   icon: "i_group29"
      // },
      // {
      //   name: "凝心聚力工作平台",
      //   route: "LaborUnion",
      //   icon: "i_group30"
      // },
      // {
      //   name: "三重一大决策管理",
      //   route: "DecisionManagementCreat",
      //   icon: "i_group31"
      // }
      ];
      // if(unit_category==2){
        this.BranchMenu.splice(9, 0, ...linshi);
      // }
      this.OrgMenu.splice(9,0,...linshi)
      this.getMeta()
    }
  }
</script>
<style scoped>
  .icon {
    width: 50px;
    height: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Works/index.vue